import {EventSourceContainer} from './event-source-container';

export default {
    component: EventSourceContainer
};
